export default "__VITE_ASSET__C63AEWjs__"